import { PoolMetadataCoreType } from "@renec-foundation/relend-adapter"
import { atom } from "jotai"

export type SetupOnChainDataAtomType = {
  config?: PoolMetadataCoreType[]
  metadata?: any
  rateLimiter?: any
  solendRateLimiter?: any
  publicKey?: any
  walletData?: any
}

// Data atoms
export const setupOnChainDataAtom = atom<SetupOnChainDataAtomType>({})

// Loading state
export type SetupOnChainLoadingStep = "config" | "metadata" | "publicKey" | "walletData" | "complete"

export const setupOnChainLoadingStepAtom = atom<SetupOnChainLoadingStep>("config")

// Error state
export const setupOnChainErrorAtom = atom<Error | null>(null)

// Refresh state management
type ShouldRefreshSetupOnChainAtom = {
  [key in SetupOnChainLoadingStep]: boolean
}

export const shouldRefreshSetupOnChainAtom = atom<ShouldRefreshSetupOnChainAtom>({
  config: false,
  metadata: false,
  publicKey: false,
  walletData: false,
  complete: false,
})

export type SetupOnChainRefreshKeys = keyof ShouldRefreshSetupOnChainAtom | (keyof ShouldRefreshSetupOnChainAtom)[]

export const refreshSetupOnChainByKeyAtom = atom(
  (get) => get(shouldRefreshSetupOnChainAtom),
  (_, set, key: SetupOnChainRefreshKeys) => {
    const keys = Array.isArray(key) ? key : [key]
    set(shouldRefreshSetupOnChainAtom, (prev) => ({
      ...prev,
      ...Object.fromEntries(keys.map((k) => [k, true])),
    }))
    set(setupOnChainLoadingStepAtom, "config")
  },
)

export const resetSetupOnChainRefreshKeyAtom = atom(
  (get) => get(shouldRefreshSetupOnChainAtom),
  (_, set, key: SetupOnChainRefreshKeys) => {
    const keys = Array.isArray(key) ? key : [key]
    set(shouldRefreshSetupOnChainAtom, (prev) => ({
      ...prev,
      ...Object.fromEntries(keys.map((k) => [k, false])),
    }))
  },
)
